import { CloseRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { MinutesProps } from '../../services/requests/ata/types';
import { Header, Title } from './styles';

interface DrawerToSignProps {
  setOpenDrawerToSign: (type: boolean) => void;
  urlToSign: string;
  setMinute: (a: MinutesProps) => void;
  minute: MinutesProps;
  stateControlMinute: boolean;
  setStateControlMinute: (type: boolean) => void;
}

export const DrawerToSign = ({
  setOpenDrawerToSign,
  urlToSign,
  setMinute,
  minute,
  stateControlMinute,
  setStateControlMinute,
}: DrawerToSignProps) => {
  const handleClose = () => {
    setOpenDrawerToSign(false);
    setStateControlMinute(true);
  };

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data === 'signed') {
          setMinute({
            ...minute,
            signed: true,
            status: 'CS2',
          });
          setOpenDrawerToSign(false);
          setStateControlMinute(true);
          // handleEditSignatures();
          toast.success('Assinado com sucesso!', { toastId: 1 });
        }
        if (event.data === 'wrong-data') {
          toast.error('Erro na assinatura');
        }
      },
      false,
    );
  }, [minute, setMinute, setOpenDrawerToSign, setStateControlMinute]);

  return (
    <Box width="95vw" height="100%" padding="20px">
      <Header>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={handleClose}
        />
        <Title>{minute?.signed ? 'Visualizar documento' : 'Assinar'}</Title>
      </Header>
      <Box
        sx={{
          height: '95%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <embed src={urlToSign} style={{ width: '800px', height: '100%' }} />
      </Box>
    </Box>
  );
};
